import { TemplateResult, html, CSSResultGroup } from 'lit';
import { property } from 'lit/decorators.js';
import { BlocksElement } from '../BlocksElement';
import type { FieldStatus } from './field-note.model';
import styles from './field-note.styles';

/**
 * @slot default - The note content
 * @csspart base - The component's base wrapper.
 * @csspart part-default - The component's default slot.
 */
export class BlocksFieldNote extends BlocksElement {static styles: CSSResultGroup = styles;

  /**
   * Status of fieldNote
   */
  @property({ type: String })
  status: FieldStatus;

  /**
   * Disabled state
   * 1) Changes the component's treatment to represent disabled
   */
  @property({ type: Boolean })
  isDisabled: boolean | undefined;

  render(): TemplateResult<1> {
    const componentClassName = this.componentClassNames('cat-c-field-note', {
      'cat-is-error': this.status === 'error',
      'cat-is-success': this.status === 'success',
      'cat-is-disabled': this.isDisabled
    });

    return html`
      <div part="base" class="${componentClassName}">
        <slot part="part-default"></slot>
      </div>
    `;
  }
}

if (customElements.get('cat-field-note') === undefined) {
  customElements.define('cat-field-note', BlocksFieldNote);
}

declare global {
  interface HTMLElementTagNameMap {
    'cat-field-note': BlocksFieldNote;
  }
}
